/**
 * Date-extensions locale Slovak [sk]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('sk', {
    monthNames: ['Január','Február','Marec','Apríl','Máj','Jún','Júl','August','September','Október','November','December'],
    monthShortNames: ['Jan','Feb','Mar','Apr','Máj','Jún','Júl','Aug','Sep','Okt','Nov','Dec'],
    dayNames: ['Nedeľa','Pondelok','Utorok','Streda','štvrtok','Piatok','Sobota'],
    dayShortNames: ['Ne','Po','Ut','St','št','Pi','So']
});
